'use client';

import { c as _c } from "react/compiler-runtime";
import { useCouponId, useCouponIndices, useCouponPrice } from '@svenskaspelab/poolbetting/core/nextjs/coupon';
import type { CouponIndex } from '@svenskaspelab/poolbetting/schema/coupon';
import { CouponSelection } from '@svenskaspelab/poolbetting/ui/Coupon';
import { TipsenLink } from '@svenskaspelab/poolbetting/ui/TipsenLink';
import { TabLink, TabLinks } from '@svenskaspelab/ui/react/tabs-link';
import { type ReactNode } from 'react';
function CouponSelectionContainer(t0) {
  const $ = _c(22);
  const {
    couponIndex
  } = t0;
  const [couponId, selectedCouponIndex] = useCouponId();
  let t1;
  if ($[0] !== couponId) {
    t1 = {
      couponId
    };
    $[0] = couponId;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const couponIndices = useCouponIndices(t1);
  let t2;
  if ($[2] !== couponId || $[3] !== couponIndex) {
    t2 = {
      couponId,
      couponIndex
    };
    $[2] = couponId;
    $[3] = couponIndex;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const price = useCouponPrice(t2);
  const isSelectedCoupon = selectedCouponIndex === couponIndex;
  const t3 = `Ta bort kupong ${couponIndex + 1}`;
  let t4;
  if ($[5] !== couponIndex || $[6] !== t3) {
    t4 = {
      name: "delete",
      type: "submit",
      form: "coupon_form",
      value: couponIndex,
      label: t3
    };
    $[5] = couponIndex;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== couponIndex) {
    t5 = <TipsenLink href={{
      query: {
        coupon: couponIndex
      }
    }} scroll={false} queriesToKeep="ALL" />;
    $[8] = couponIndex;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const t6 = `${couponIndex + 1}`;
  let t7;
  if ($[10] !== t6) {
    t7 = <span className="sr-only">Kupong {t6}</span>;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== couponIndex || $[13] !== couponIndices.length || $[14] !== price) {
    t8 = <CouponSelection price={price} couponIndex={couponIndex} numberOfCoupons={couponIndices.length} />;
    $[12] = couponIndex;
    $[13] = couponIndices.length;
    $[14] = price;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== isSelectedCoupon || $[17] !== t4 || $[18] !== t5 || $[19] !== t7 || $[20] !== t8) {
    t9 = <TabLink className="relative" isActive={isSelectedCoupon} closeButtonProps={t4} render={t5}>{t7}{t8}</TabLink>;
    $[16] = isSelectedCoupon;
    $[17] = t4;
    $[18] = t5;
    $[19] = t7;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  return t9;
}

/**
 * Coupon Selection Container for smaller device.
 *
 * @returns CouponSelectionContainer component
 */
// eslint-disable-next-line react/no-multi-comp
export default function CouponsSelectionContainer() {
  const $ = _c(6);
  const [couponId] = useCouponId();
  let t0;
  if ($[0] !== couponId) {
    t0 = {
      couponId
    };
    $[0] = couponId;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const couponIndices = useCouponIndices(t0);
  if (couponIndices.length <= 1) {
    return;
  }
  let t1;
  if ($[2] !== couponIndices) {
    t1 = couponIndices.map(_temp);
    $[2] = couponIndices;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t1) {
    t2 = <TabLinks alignment="left" context="surface" className="rounded-b-none px-1 lg:hidden">{t1}</TabLinks>;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}
function _temp(index) {
  return <CouponSelectionContainer key={index} couponIndex={index} />;
}